import React, { useEffect, useState } from 'react'
import { Modal } from 'reactstrap';
import GenericForm from './genericForms';
import { RecordState, setRecordState } from '../Store/Generic/GenericSlice';
import { useDispatch, useSelector } from "react-redux";


const AddEditModel: React.FC = () => {
    const dispatch = useDispatch();
    const AddRecordState: RecordState = 'NEW';
    const EditRecordState: RecordState = 'EDIT';
    const { recordState, recordID } = useSelector((state: any) => state.Generic);
    const [addEditModel, setAddEditModel] = useState(false);
    useEffect(() => {
        setAddEditModel(true)
    }, [recordState]);

    if ((recordState !== AddRecordState) && (recordState !== EditRecordState)) return null;

    return (
        <>
            <Modal
                isOpen={addEditModel}
                toggle={() => {
                    setAddEditModel(!addEditModel)
                }}
                backdrop={"static"}
            >
                <div className="modal-header">
                    <h5 className="modal-title mt-0" id="myExtraLargeModalLabel" > {recordID !== -1 ? ('Edit Record') : ('Add New')} </h5>
                    <button
                        onClick={() => {
                            dispatch(setRecordState(null));
                        }}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <GenericForm key={`form-${recordID}`} />
                </div>
            </Modal>
        </>
    )
}
export default AddEditModel;
